/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';

import Switcher from 'components/Switcher';

import './PermissionsDetailsSimple.scss';

const b = block('permissions-details-simple-desktop');

const PermissionsDetailsSimple = ({ isActive, onChange, title }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  return (
    <section className={b()}>
      <div className={b('title')} dangerouslySetInnerHTML={{ __html: locale[title] ?? title }} />
      <div className={b('switcher')}>
        <Switcher
          isActive={isActive}
          onSwitch={onChange}
        />
      </div>
    </section>
  );
};

export default PermissionsDetailsSimple;
